






























import Vue from 'vue';
import axios from 'axios';
import { buildPagination } from '../utils/pagination';

export default Vue.extend({
    name: 'Forms',
    data() {
        return {
            forms: [] as any[],
            searchResultForms: [] as any[],
            currentPageNum: 1 as number,
            searchQ: '',
            numItems: 10,
            pagination: [] as (number | '...')[],
            isSearchResult: false,
            isSearching: false,
            totalFormsCount: 0
        }
    },
    created() {
        if(this.$route.query.page) {
            this.currentPageNum = parseInt(this.$route.query.page as any);
        }
        this.getCustomTemplates();
        this.getFormsCount();
        this.getForms()
            .then(() => {
                this.$store.state.routeLoaded = true;
            });
    },
    methods: {
        async getFormsCount() {
            await axios.get(`${this.$store.state.apiUrl}/forms/count`)
                .then(resp => {
                    this.totalFormsCount = resp.data.total;
                    if(!this.isSearchResult) {
                        this.pagination = buildPagination(this.currentPageNum, Math.ceil(this.totalFormsCount / this.numItems));
                    }
                })
                .catch(e => {
                    console.log(e);
                });
        },
        async getForms() {
            this.isSearchResult = false;
            const url = `${this.$store.state.apiUrl}/forms?pageNum=${this.currentPageNum}&numItems=${this.numItems}`;
            await axios.get(url)
                .then(resp => {
                    this.forms = resp.data;
                    this.pagination = buildPagination(this.currentPageNum, Math.ceil(this.totalFormsCount / this.numItems));
                })
                .catch(e => {
                    console.log(e);
                });
        },
        async searchForms() {
            this.currentPageNum = 1;
            if(!this.searchQ) {
                this.getForms();
                return;
            }
            this.isSearching = true;
            this.isSearchResult = true;
            const url = `${this.$store.state.apiUrl}/forms/search?searchQ=${this.searchQ}`;
            await axios.get(url)
                .then(resp => {
                    this.searchResultForms = resp.data;
                    this.forms = this.searchResultForms.slice(0, this.numItems);
                    this.pagination = buildPagination(this.currentPageNum, Math.ceil(this.searchResultForms.length / this.numItems));
                })
                .catch(e => {
                    console.log(e);
                });
            this.isSearching = false;
        },
        async getCustomTemplates() {
            await axios.get(`${this.$store.state.apiUrl}/custom-templates`)
                .then(resp => {
                    this.$store.state.customTemplates = resp.data;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        changePage(num: number) {
            this.currentPageNum = num;
            if(this.isSearchResult) {
                this.forms = this.searchResultForms.slice((this.numItems * (this.currentPageNum - 1)), (this.numItems * this.currentPageNum));
                this.pagination = buildPagination(this.currentPageNum, Math.ceil(this.searchResultForms.length / this.numItems));
            } else {
                this.getForms();
            }
        },
        clearSearch() {
            this.currentPageNum = 1;
            this.searchQ = '';
            this.getForms();
        }
    }
})
